import * as React from 'react';

import { FromToControl } from '../../../../../../../common/components/from_to_control';
import { FOfferType, isUrban, isSuburban } from '../../../../../../../utils/category';
import { TArea } from '../../../../../../state/advanced/area';
import { InlineBlock, InlineLabel } from '../../../../../advanced/markup';
import * as styles from './area.css';

export interface IAreaOwnProps {
  offerType: FOfferType;
}

export interface IAreaStateProps {
  totalAreaMin: number | undefined;
  totalAreaMax: number | undefined;
  roomAreaMin: number | undefined;
  roomAreaMax: number | undefined;
  livingAreaMin: number | undefined;
  livingAreaMax: number | undefined;
  kitchenAreaMin: number | undefined;
  kitchenAreaMax: number | undefined;
  siteAreaMin: number | undefined;
  siteAreaMax: number | undefined;
}

export interface IAreaDispatchProps {
  onMinAreaChanged(param: TArea, value: number | undefined): void;
  onMaxAreaChanged(param: TArea, value: number | undefined): void;
}

type TAreaProps = IAreaOwnProps & IAreaStateProps & IAreaDispatchProps;

export class Area extends React.Component<TAreaProps> {
  public render() {
    const { props } = this;
    const { offerType } = props;

    return (
      <>
        <InlineLabel>{isUrban(offerType) ? 'Общая' : 'Дом'}&nbsp;</InlineLabel>
        <InlineBlock customStyles={styles['inlineParam']}>
          <FromToControl
            rangeGroupStyle={{ marginRight: isSuburban(offerType) ? 8 : 0, flex: 1, width: 120 }}
            from={{
              value: props.totalAreaMin,
              placeholder: 'от',
              onValueChange: value => props.onMinAreaChanged('total_area', value),
            }}
            to={{
              value: props.totalAreaMax,
              placeholder: 'до',
              onValueChange: value => props.onMaxAreaChanged('total_area', value),
            }}
          />
          {isSuburban(offerType) && 'м\u00B2'}
        </InlineBlock>

        {isUrban(offerType) && (
          <>
            {(offerType & (FOfferType.Room | FOfferType.Bed)) !== 0 && (
              <>
                <InlineLabel>Комната&nbsp;</InlineLabel>
                <InlineBlock>
                  <FromToControl
                    rangeGroupStyle={{ width: 120 }}
                    from={{
                      //из api площадь комнаты приходит как строка - был баг с отображениеим значений
                      value: typeof props.roomAreaMin === 'string' ? +props.roomAreaMin : props.roomAreaMin,
                      placeholder: 'от',
                      onValueChange: value => props.onMinAreaChanged('room_area', value),
                    }}
                    to={{
                      value: typeof props.roomAreaMax === 'string' ? +props.roomAreaMax : props.roomAreaMax,
                      placeholder: 'до',
                      onValueChange: value => props.onMaxAreaChanged('room_area', value),
                    }}
                  />
                </InlineBlock>
              </>
            )}

            <InlineLabel>Кухня&nbsp;</InlineLabel>
            <InlineBlock>
              <FromToControl
                rangeGroupStyle={{ width: 120 }}
                from={{
                  value: props.kitchenAreaMin,
                  placeholder: 'от',
                  onValueChange: value => props.onMinAreaChanged('kitchen', value),
                }}
                to={{
                  value: props.kitchenAreaMax,
                  placeholder: 'до',
                  onValueChange: value => props.onMaxAreaChanged('kitchen', value),
                }}
              />
            </InlineBlock>

            {(offerType & (FOfferType.Flat | FOfferType.FlatShared)) !== 0 && (
              <>
                <InlineLabel>Жилая&nbsp;</InlineLabel>
                <InlineBlock>
                  <FromToControl
                    rangeGroupStyle={{ width: 120 }}
                    from={{
                      value: props.livingAreaMin,
                      placeholder: 'от',
                      onValueChange: value => props.onMinAreaChanged('living_area', value),
                    }}
                    to={{
                      value: props.livingAreaMax,
                      placeholder: 'до',
                      onValueChange: value => props.onMaxAreaChanged('living_area', value),
                    }}
                  />
                </InlineBlock>
              </>
            )}
          </>
        )}
        {isSuburban(offerType) && (
          <>
            <InlineLabel>Участок&nbsp;</InlineLabel>
            <InlineBlock customStyles={styles['inlineParam']}>
              <FromToControl
                rangeGroupStyle={{ marginRight: 8, flex: 1, width: 120 }}
                from={{
                  value: props.siteAreaMin,
                  placeholder: 'от',
                  onValueChange: value => props.onMinAreaChanged('site_area', value),
                }}
                to={{
                  value: props.siteAreaMax,
                  placeholder: 'до',
                  onValueChange: value => props.onMaxAreaChanged('site_area', value),
                }}
              />
              сот.
            </InlineBlock>
          </>
        )}
      </>
    );
  }
}
